import { Register } from "./Register";
import { RegisterV2 } from "./RegisterV2";
import { useDetectedBrandSlug } from "../hooks/useDetectedBrandSlug";

const KN_BRAND_SLUG = "kiedynabory";

/**
 * Flag is read synchronously on every render (build-time process.env wins over
 * runtime window._env_), so the flag-off path never triggers brand detection.
 */
function isKnRegistrationV2Enabled(): boolean {
  const value =
    process.env.REACT_APP_KN_REGISTRATION_V2_ENABLED ??
    (typeof window !== "undefined"
      ? window._env_?.REACT_APP_KN_REGISTRATION_V2_ENABLED
      : undefined);
  return String(value).trim().toLowerCase() === "true";
}

/** v2 only for brand `kiedynabory`; detection failure or other brand -> v1 (fail closed). */
const BrandSwitchedRegister = () => {
  const { slug, isLoading } = useDetectedBrandSlug();

  if (isLoading) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="min-h-screen flex items-center justify-center bg-gray-50"
      >
        Ładowanie…
      </div>
    );
  }

  return slug === KN_BRAND_SLUG ? <RegisterV2 /> : <Register />;
};

export const RegisterRoute = () =>
  isKnRegistrationV2Enabled() ? <BrandSwitchedRegister /> : <Register />;
